<ng-template #content let-modal>
  <div class="modal-header red">
    <div class="container-fluid">
      <div class="row modal-header-row">
        <img class="modal-icon" src="assets/ico/exclamation-triangle-regular-white.svg" alt="icon">
        <span class="modal-title" id="modal-basic-title">Error</span>

      </div>
    </div>
  </div>
  <div class="modal-body">
    @for (error of errors; track error; let last = $last) {
      <div>
        <p [class.pb-5]="errors.length > 1 && !last">
          @if (error.message) {
            <span class="error-details"><strong>{{error.message}}</strong></span>
          }
          @if (error.details) {
            <span class="error-secondary-details">{{error.details}}</span>
          }
          @if (!error.message && !error.details) {
            <span
              class="error-details"><strong>{{'modals.error.unknownError' | translate}}</strong></span>
            }
            @for (item of error.validationErrors; track item; let i = $index) {
              <div class="error-secondary-details mt-3">
                @if (item.fieldName) {
                  <span> <strong>{{'columnName.' + item.fieldName |
                  translate}}:</strong></span>
                }
                {{item.message}}
              </div>
            }
            @if (error.errorTraceId) {
              <span class="error-secondary-details"
                style="margin-top: 2em;"><strong>{{'modals.error.traceID' | translate}}:
              </strong>{{error.errorTraceId}}</span>
            }
          </p>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn modal-btn" (click)="close()">OK</button>
    </div>
  </ng-template>